import React, { useCallback, useState, useContext } from "react";
import { useEffect } from "react";
import { useDropzone } from "react-dropzone";
import apiClient from "../libraries/ApiClient";
import { ModelContext } from "../contexts/ModelContext";

function Upload({ setImageOrVideo, disabled }) {
  const [file, setFile] = useState([]);
  const [limitedFiles, setLimitedFiles] = useState([]);
  const { setChangeData } = useContext(ModelContext);

  useEffect(() => {
    const imageFiles = file.filter(
      (file) => file.type === "image/jpeg" || file.type === "image/png"
    );
    const overImageFiles = imageFiles.splice(10);
    const videoFiles = file.filter(
      (file) =>
        file.type === "video/mp4" ||
        file.type === "video/mp3" ||
        file.type === "video/wav" ||
        file.type === "video/quicktime"
    );
    const overVideoFiles = videoFiles.splice(2);

    if (overImageFiles.length > 0) {
      alert("照片上限為10張，會依據順序選擇前10張");
    }
    if (overVideoFiles.length > 0) {
      alert("影片上限為2部，會依據順序選擇前2部");
    }

    const limitedFiles = [...imageFiles, ...videoFiles];
    setLimitedFiles(limitedFiles);
  }, [file]);

  useEffect(() => {
    //console.log(limitedFiles);
    setImageOrVideo(limitedFiles);
  }, [limitedFiles]);

  const onDrop = useCallback((file) => {
    setChangeData(true);
    const imageFiles = file.filter(
      (file) => file.type === "image/jpeg" || file.type === "image/png"
    );
    const videoFiles = file.filter(
      (file) =>
        file.type === "video/mp4" ||
        file.type === "video/mp3" ||
        file.type === "video/wav" ||
        file.type === "video/quicktime"
    );

    const imageFilesLength = imageFiles.length;
    const videoFilesLength = videoFiles.length;

    apiClient.logOfActionWithoutId("Upload", "onDrop", {
      imageFilesLength,
      videoFilesLength,
    });

    const imageSizeFilter = imageFiles.filter((file) => file.size > 10000000);
    const videoSizeFilter = videoFiles.filter((file) => file.size > 50000000);
    if (imageSizeFilter.length > 0 || videoSizeFilter.length > 0) {
      const imageAlertFilter = imageSizeFilter
        .map((file) => file.name)
        .join("、");
      const videoAlertFilter = videoSizeFilter
        .map((file) => file.name)
        .join("、");
      const imageSizeOtherFilter = imageFiles.filter(
        (file) => file.size < 100000000
      );
      const videoSizeOtherFilter = videoFiles.filter(
        (file) => file.size < 100000000
      );
      setFile((prev) => [
        ...prev,
        ...imageSizeOtherFilter,
        ...videoSizeOtherFilter,
      ]);
      if (imageSizeFilter.length > 0) {
        alert(`${imageAlertFilter}照片大小超過限制`);
      }
      if (videoSizeFilter.length > 0) {
        alert(
          `${videoAlertFilter}影片大小超過限制，可減少影片長度或品質以降低容量`
        );
      }
      return;
    }

    setFile((prev) => [...prev, ...file]);
  }, []);
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: {
      "image/png": [".png"],
      "image/jpeg": [".jpeg"],
      "video/mp4": [".mp4"],
      "video/mp3": [".mp3"],
      "video/wav": [".wav"],
      "video/quicktime": [".mov"],
    },
    disabled: disabled,
    multiple: true,
  });

  //console.log(limitedFiles);
  const delFile = (files, delPreFile) => {
    // console.log(file);
    const aaa = limitedFiles.filter((v, i) => {
      return v.name !== files;
    });
    URL.revokeObjectURL(delPreFile);
    setFile(aaa);
    //console.log(limitedFiles);
  };

  const files = limitedFiles.map((file) => (
    <div
      style={{
        display: "flex",
        alignItems: "flex-start",
        border: "1px solid #ccc",
        borderRadius: "8px",
        padding: "16px 24px",
        background: "#fff",
        position: "relative",
        margin: "4px",
      }}
      key={file.path}
    >
      {file.type === "video/mp4" ||
      file.type === "video/mp3" ||
      file.type === "video/wav" ||
      file.type === "video/quicktime" ? (
        <video width={100} style={{ paddingRight: "8px" }}>
          <source src={URL.createObjectURL(file)} />
        </video>
      ) : (
        <img
          src={URL.createObjectURL(file)}
          alt=""
          width={"100px"}
          style={{ paddingRight: "8px" }}
        />
      )}

      <div>{file.name}</div>
      <i
        className="fa-solid fa-xmark"
        style={{
          position: "absolute",
          top: "8px",
          right: "8px",
          cursor: "pointer",
        }}
        onClick={() => {
          delFile(file.name, URL.createObjectURL(file));
        }}
      ></i>
    </div>
  ));

  return (
    <section
      style={{
        border: "1px solid #818181",
        borderRadius: "4px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        background: "#F0FBFF",
        padding: "8px",
      }}
    >
      <div {...getRootProps()} style={{ padding: "8px 0px" }}>
        <input {...getInputProps()} />
        <p style={{ cursor: "pointer" }}>拖拉檔案到此，或點此選擇檔案</p>
      </div>
      <aside>
        <ul>{files}</ul>
      </aside>
    </section>
  );
}

export default Upload;
